'use strict';

const angular = require('angular');

const uiRouter = require('angular-ui-router');
const _ = require('lodash');

import routes from './uba.routes';
import showHtml from './model/show.html';
import addHtml from './model/add.html';
import editOnedayHtml from './model/edit.oneday.html';
import editSilentHtml from './model/edit.silent.html';
import editPrayHtml from './model/edit.pray.html';

export class UbaComponent {
  // filters = {
  //   language_type: "en",
  //   trinity: "oneday",
  // };
    filters = {
        language_type: 'en',
        trinity: 'oneday',
        date: new Date(),
    };
    uba = {};
    currentPage = 1;
    point = {}
  /*@ngInject*/
    constructor(
    $http,
    $scope,
    socket,
    $uibModal,
    $cookies,
    $cookieStore,
    $location
  ) {
        this.$http = $http;
        this.socket = socket;
        this.$uibModal = $uibModal;
        this.$cookies = $cookies;
        this.$cookieStore = $cookieStore;
        this.$location = $location;

        this.language_type_selector = [
      { value: '', name: '选择语言' },
      { value: 'en', name: '英语' },
      { value: 'pt', name: '葡语' },
      { value: 'es', name: '西语' },
      { value: 'de', name: '德语' },
      { value: 'fr', name: '法语' },
      { value: 'zh_hans', name: '中简' },
      { value: 'zh_hant', name: '中繁' },
        ];
        this.trinity_selector = [
      { value: '', name: '选择内容类型' },
      { value: 'oneday', name: '阅读' },
      { value: 'silent', name: '默想' },
      { value: 'pray', name: '祷告' },
        ];
        this.pointName = {
            dailyVerse_read: 'verse点击率',
            Share_DailyVerse_Click: 'verse分享率',
            Share_DailyVerse_Image_Click: 'verse图片分享率',
            Share_DailyVerse_Text_click: 'verse文字分享率',
            verse_Show: 'verse展示率',
            pray_start_button: 'verse祷告开始率',
            pray_share_meditation: 'meditation分享率',
            pray_share_pray: 'pray分享率',
            NewPray_Amen: 'Amen率',
        };
    }

    $onInit() {
        this.search();
    }

    showContent(content, title) {
        this.$uibModal.open({
            template: showHtml,
            size: 'lg',
      /*@ngInject*/
            controller($scope, $http, $uibModalInstance) {
                $scope.content = content;
                $scope.title = title;
                $scope.cancel = function() {
                    $uibModalInstance.close();
                };
            },
        });
    }

    createOne() {
        const that = this;
        this.$uibModal.open({
            template: addHtml,
            size: 'lg',
      /*@ngInject*/
            controller($scope, $http, $uibModalInstance, FileUploader) {
                $scope.vm = {
                    date_no: 'Day',
                    language_type_selector: that.language_type_selector,
                    language_type: '',
                };
                $scope.cancel = function() {
                    $uibModalInstance.close();
                };

                $scope.save = function(myForm) {
                    if(myForm.$valid === false) {
                        return false;
                    } else {
                        $http
              .post('/api/ubas/trinity', {
                  type: 'create',
                  filters: that.filters,
                  entity: $scope.vm,
              })
              .then(
                (response) => {
                    that.$onInit();
                    $uibModalInstance.close();
                },
                (error) => {
                    console.log(error);
                }
              );
                    }
                };
            },
        });
    }

    edit(item) {
        let template;
        switch (this.filters.trinity) {
        case 'oneday':
            template = editOnedayHtml;
            break;
        case 'silent':
            template = editSilentHtml;
            break;
        case 'pray':
            template = editPrayHtml;
            break;

        default:
            break;
        }
        const that = this;
        this.$uibModal.open({
            template,
            size: 'lg',
      /*@ngInject*/
            controller($scope, $http, $uibModalInstance, FileUploader) {
                $scope.vm = item;
                $scope.cancel = function() {
                    $uibModalInstance.close();
                };

                $scope.save = function(myForm) {
                    if(myForm.$valid === false) {
                        return false;
                    } else {
                        $http
              .post('/api/ubas/trinity', {
                  type: 'edit',
                  filters: that.filters,
                  entity: $scope.vm,
              })
              .then(
                (response) => {
                    that.$onInit();
                    $uibModalInstance.close();
                },
                (error) => {
                    console.log(error);
                }
              );
                    }
                };
            },
        });
    }

    delete(ad) {
        this.$http.delete(`/api/ad_defaults/${ad._id}`).then((response) => {
            this.$onInit();
        });
    }

    search() {
    // console.log(this.filters.trinity, this.filters.language_type);
        if(this.filters.trinity && this.filters.language_type) {
            this.$http
        .get('/api/ubas/trinity', {
            params: {
                page: this.currentPage - 1,
                size: 10,
                date: this.filters.date,
                trinity: this.filters.trinity,
                language_type: this.filters.language_type,
            },
        })
        .then((response) => {
          // console.log(response);
            if(response.data.data) {
                this.maxSize = 10;
                this.totalCount = response.data.data.count;
                this.totalItems = response.data.data.count;

                this.array = response.data.data.rows;
                this.uba = response.data.data.uba;
                this.getAllTrinity();
            }
        });
        }
    }

  /**
   * 计算埋点数据
   */
    computePoint() {
        console.log(this.uba, '+++++++++');
        for(let ubaKey of Object.keys(this.uba)) {
            if(this.uba[ubaKey] !== 'sumCount' && !_.isEmpty(this.uba[ubaKey].numerator) && this.uba[ubaKey].denominator) {
                let Share_DailyVerse = 0;
                for(let ubaData of this.uba[ubaKey].numerator) {
                    ubaData.name_zh = this.pointName[ubaData.name];
                    if(ubaData.name === 'Share_DailyVerse_Image_Click' || ubaData.name === 'Share_DailyVerse_Text_click') {
                        Share_DailyVerse += ubaData.count;
                    }
                    ubaData.percentage = (ubaData.count / this.uba[ubaKey].denominator * 100).toFixed(2) + '%';
                    ubaData.percentageNum = `${ubaData.count} / ${this.uba[ubaKey].denominator}`;
                }
                const Share_DailyVerse_Click = {
                    name: 'Share_DailyVerse_Click',
                    count: Share_DailyVerse,
                    percentage: (Share_DailyVerse / this.uba[ubaKey].denominator *
              100).toFixed(2) + '%',
                    name_zh: 'verse分享率',
                    percentageNum: `${Share_DailyVerse} / ${this.uba[ubaKey].denominator}`
                };
                this.uba[ubaKey].numerator.push(Share_DailyVerse_Click);
                const verse_Show = {
                    name: 'verse_Show',
                    count: this.uba[ubaKey].denominator,
                    percentage: (this.uba[ubaKey].denominator / this.uba.sumCount *
                  100).toFixed(2) + '%',
                    name_zh: 'verse展示率',
                    percentageNum: `${this.uba[ubaKey].denominator} / ${this.uba.sumCount}`
                };
                this.uba[ubaKey].numerator.push(verse_Show);
            }
        }
        console.log('ubaData+++++++++', this.uba);
    }
    getAllTrinity() {
        this.$http.get('/api/ubas/trinity/queryAllInfo/v1.0', {
            params: {
                date: this.filters.date,
                trinity: this.filters.trinity,
                language_type: this.filters.language_type,
            },
        }).then(allTrinityInfo => {
            this.uba.sumCount = allTrinityInfo.data.data.length;
            // eslint-disable-next-line newline-per-chained-call
        }).then(() => {
            this.computePoint();
        });
    }
}

export default angular
  .module('tttApp.uba', [uiRouter])
  .config(routes)
  .component('uba', {
      template: require('./uba.html'),
      controller: UbaComponent,
  }).name;



// WEBPACK FOOTER //
// ./client/app/uba/uba.component.js